import React from 'react';

export default function SkipNav() {
  return (
    <div className="skip-nav visually-hidden-focusable overflow-hidden">
      <div className="container-xl">
        <a href="#main" className="d-inline-flex p-2 m-1">
          Skip to main content
        </a>
      </div>
    </div>
  );
}
